export default "__VITE_ASSET__DkLbkLWq__"